import { Component, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-header-intl',
  templateUrl: './header-intl.component.html',
  styleUrls: ['./header-intl.component.scss']
})
export class HeaderIntlComponent implements OnInit {
  public urls: any = {};

  menuOpen= false;
  maxFontSizeAllowed : number = 0;
  minFontSizeAllowed : number = 0;
  constructor(public router: Router) {}

  ngOnInit(): void {
    this.urls = environment.AppRedirectUrls;
  }

  scroll(id: string) {
    console.log(`scrolling to ${id}`);
    let el: any = document.getElementById(id);
    el.scrollIntoView();
  }

  changeFontSize(event:any) {
    let buttonId = event.target.id;
    const textElements:any = document.querySelectorAll(".accessibility-plugin-ac");
    if(buttonId === "increase-plugin-ac"){
      this.maxFontSizeAllowed = this.maxFontSizeAllowed + 1;
      if(this.minFontSizeAllowed > 0){
        this.minFontSizeAllowed = this.minFontSizeAllowed - 1;
      }

    }else if(buttonId === "normal-plugin-ac"){
      this.maxFontSizeAllowed = 0;
      this.minFontSizeAllowed = 0;
    }else{
      this.minFontSizeAllowed = this.minFontSizeAllowed + 1;
      if(this.maxFontSizeAllowed > 0){
        this.maxFontSizeAllowed = this.maxFontSizeAllowed - 1;
      }
    }

     for (let i = 0; i < textElements.length; i++) {
      let fontsizevalue:any =  window.getComputedStyle(textElements[i], null).getPropertyValue('font-size');
      let currentFontSize:any;

      currentFontSize = parseInt(fontsizevalue.replace("px", ""));

      if(textElements[i].getAttribute("default-font-size") === null){

        let att = document.createAttribute("default-font-size");

        att.value = currentFontSize.toString();

        textElements[i].setAttributeNode(att);

      }

      if(buttonId === "increase-plugin-ac"){

        currentFontSize = currentFontSize + 1;

      }else if(buttonId === "normal-plugin-ac"){

        currentFontSize = textElements[i].getAttribute("default-font-size");

      }else{

        currentFontSize = currentFontSize - 1;

      }

      textElements[i].style.fontSize = currentFontSize + "px";

    }

  }





}


